import { render, staticRenderFns } from "./literacyCourseLearning.vue?vue&type=template&id=5ce3165a&scoped=true&"
import script from "./literacyCourseLearning.vue?vue&type=script&lang=js&"
export * from "./literacyCourseLearning.vue?vue&type=script&lang=js&"
import style0 from "./literacyCourseLearning.vue?vue&type=style&index=0&id=5ce3165a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce3165a",
  null
  
)

export default component.exports